export default {
  'auth.email.suggestion': 'Bedoelde je {email}?',
  'auth.email.typoError': 'Controleer je e-mailadres.',
  'auth.email.disposableError':
    'Gebruik een vast e-mailadres. Wegwerpadressen kunnen we helaas niet accepteren.',
  'auth:common:label-email': 'E-mail',
  'auth:common:label-email:focus': 'Jouw e-mailadres',
  'auth:common:label-password': 'Wachtwoord',
  'auth:common:label-new-password': 'Nieuw wachtwoord',
  'auth:common:label-repeat-new-password': 'Nieuw wachtwoord herhalen',
  'auth:common:button:to-login': 'Naar inloggen',

  'auth:activate-account:header': 'Account activeren',
  'auth:activate-account:sub-header': 'Stel een wachtwoord in voor je account',
  'auth:activate-account:account-activated': 'Je account is geactiveerd.',
  'auth:activate-account:button:activate': 'Account activeren',
  'auth:activate-account:error-message': 'Er is een fout opgetreden. Probeer het later opnieuw!',

  'auth:login:header': 'Inloggen',
  'auth:login:header:otp': 'Inloggen met eenmalige code',
  'auth:login:sheet:header': 'Welkom bij Pets Deli',
  'auth:login:label:password': 'Wachtwoord',
  'auth:login:button:login': 'Inloggen',
  'auth:login:button:recover-password': 'Wachtwoord vergeten?',
  'auth:login:link:create-new-account': 'Nu aanmaken',
  'auth:login:question:dont-you-have-an-account': 'Nog geen account?',

  'auth:signup:label:password': 'Wachtwoord',
  'auth:signup:label:confirmPassword': 'Wachtwoord bevestigen',
  'auth:signup:label:submitButton': 'Verder',
  'auth:signup:header-title:register': 'Registreren',
  'auth:signup:link:log-in': 'Inloggen',
  'auth:signup:question:do-you-have-an-account': 'Heb je al een account?',
  'auth:signup:hint:min-length-12': 'Het wachtwoord moet minstens 12 tekens lang zijn.',
  'auth:signup:header': 'Registreren',
  'auth:signup:success-message': 'Account aangemaakt',
  'auth:signup:show-password': 'Wachtwoord tonen',
  'auth:signup:hide-password': 'Wachtwoord verbergen',
  'auth:signup:ambassador-info':
    'Om je registratie als Pets Deli Ambassador af te ronden, maak je eerst een klantaccount aan. Daarna begeleiden we je door de volgende stappen.',

  'auth:recover-password:header': 'Wachtwoord vergeten',
  'auth:recover-password:sub-header':
    'Als er een account met dit e-mailadres bestaat, hebben we je een link gestuurd om je wachtwoord opnieuw in te stellen.',
  'auth:recover-password:button:reset-confirm': 'Wachtwoord opnieuw instellen',
  'auth:recover-password:button:back-to-login': ' Terug naar inloggen',

  'auth:reset-password:header': 'Nieuw wachtwoord instellen',
  'auth:reset-password:button:change': 'Wachtwoord wijzigen',
  'auth:reset-password:confirm': 'Je wachtwoord is succesvol gewijzigd.',
  'auth:reset-password:button:continue-purchase': 'Verdergaan met winkelen',

  'auth.login-warning.country-de': 'Duitsland',
  'auth.login-warning.country-ch': 'Zwitserland',
  'auth.login-warning.country-nl': 'Nederland',

  // Login Warning Messages, `country` is the country of the shop the account belongs to
  'auth:login-warning:title': 'Oh nee! 🐾 Je account hoort bij de shop voor {country}.',
  'auth:login-warning:message':
    'Let op: je klantaccount voor {country} kan helaas niet in deze shop worden gebruikt.',
  'auth:login-warning:link': '👉 Hier ga je naar de shop voor {country}',
  'auth:login-warning:footer': 'Bedankt voor je begrip en tot snel in de juiste shop! 💚',
};
